import { render, staticRenderFns } from "./CertificadoModal.vue?vue&type=template&id=64857256&scoped=true"
import script from "./CertificadoModal.vue?vue&type=script&lang=js"
export * from "./CertificadoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64857256",
  null
  
)

export default component.exports